const _excluded = ["value", "show", "allowByteRange", "onChange", "balice", "size", "transform"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useArchiveFileReadLazyQuery } from '@isyc-react/oc-api/queries/archive';
import { nsformfile } from "../../../i18n/namespaces";
import { useTranslation } from 'react-i18next';
import { ArchiveViewerProvider } from '@isyc-react/archives/view/viewer/context';
import { ViewerArchiveModal } from '@isyc-react/archives/view/viewer/modal';
import { ViewerArchiveContainer } from '@isyc-react/archives/view/viewer/container';
import { ViewArchiveInfoError, ViewArchiveInfoLoadingIcon } from '@isyc-react/archives/view/viewer/status';
import { getArchiveSupportsDataRange, ViewArchive } from '@isyc-react/archives/view';
import { useArchiveFilePartialReadLazyQuery } from "./archive-file-read-partial";
import { accessTokenItem } from '@isyc-react/oc-api/auth';
import '@isyc-react/design/main';
export const getOncustomerByteRangeUrl = id => {
  const token = localStorage.getItem(accessTokenItem);
  const uriToken = token ? `&atkn=${encodeURIComponent(token)}` : '';
  return `/api/archive/view?id=${id}${uriToken}`;
};
export const DropPreview = props => {
  var _value$api$id, _value$api4;
  const {
      value,
      show = false,
      allowByteRange = true,
      onChange,
      balice,
      size,
      transform
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [archive, setArchive] = React.useState(value.file ? {
    file: value.file
  } : null);
  const [getMetadata, {
    data: dataMetadata,
    error: errorMetadata
  }] = useArchiveFilePartialReadLazyQuery();
  const [getContent, {
    data: dataContent,
    error: errorContent
  }] = useArchiveFileReadLazyQuery();
  const {
    i18n
  } = useTranslation(nsformfile.common);
  const getArchiveMetadata = React.useCallback(() => {
    if (!value.file && value.api) {
      const id = value.api.id;
      getMetadata({
        variables: {
          id
        }
      });
    }
  }, []);
  const getArchiveContent = React.useCallback(() => {
    if (!value.file && value.api) {
      const id = value.api.id;
      getContent({
        variables: {
          id
        }
      });
    }
  }, []);
  React.useEffect(() => {
    var _value$api;
    if (dataMetadata && dataMetadata.archive_readFile && !errorMetadata) {
      const {
        format,
        size,
        name
      } = dataMetadata.archive_readFile;
      let dataRange = getArchiveSupportsDataRange(format);
      // if(format === 'application/pdf' && size < 8388608) dataRange = false // if less than 1MB
      if (dataRange && value.api) {
        const dataRangeUrl = getOncustomerByteRangeUrl(value.api.id);
        setArchive({
          staticUrl: {
            url: dataRangeUrl,
            mime: format
          }
        });
      } else {
        getArchiveContent();
      }
    } else if (errorMetadata) console.error(`[Archive Preview] Error getting archive metadata with id ${(_value$api = value.api) === null || _value$api === void 0 ? void 0 : _value$api.id}`);
  }, [dataMetadata, errorMetadata]);
  React.useEffect(() => {
    var _value$api2;
    if (dataContent && dataContent.archive_readFile && !errorContent) {
      const {
        content,
        format
      } = dataContent.archive_readFile;
      setArchive({
        base64: {
          data: content,
          mime: format
        }
      });
    } else if (errorContent) console.error(`[Archive Preview] Error getting archive file with id ${(_value$api2 = value.api) === null || _value$api2 === void 0 ? void 0 : _value$api2.id}`);
  }, [dataContent, errorContent]);
  React.useEffect(() => {
    if (value.file) setArchive({
      file: value.file
    });
  }, [value.file]);
  React.useEffect(() => {
    if (value.api && show) {
      if (allowByteRange) getArchiveMetadata();else getArchiveContent();
    }
  }, [value.api, show, allowByteRange]);
  const name = React.useMemo(() => {
    var _value$api3;
    return value.file ? value.file.name : (_value$api3 = value.api) === null || _value$api3 === void 0 ? void 0 : _value$api3.name;
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchiveViewerProvider, null, /*#__PURE__*/React.createElement(ViewerArchiveModal, {
    size: size,
    name: name,
    show: show,
    onChange: onChange,
    balice: balice,
    transform: transform
  }, archive ? /*#__PURE__*/React.createElement(ViewArchive, _extends({
    archive: archive,
    name: name
  }, rest)) : /*#__PURE__*/React.createElement(React.Fragment, null, errorMetadata || errorContent ? /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewArchiveInfoError, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary"
  }, "Erreur d'affichage"), /*#__PURE__*/React.createElement("p", null, "Le document avec l'id ", (_value$api$id = (_value$api4 = value.api) === null || _value$api4 === void 0 ? void 0 : _value$api4.id) !== null && _value$api$id !== void 0 ? _value$api$id : '--', " n'a pas pu \xEAtre obtenu"))) : /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: name
  }))))));
};